import { Injectable } from "@angular/core";
import { environment } from '../environments/environment';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { GetPriceMatrixForStreamResponse } from "../interfaces/feedstocklistmodel";
import { observableToBeFn } from "rxjs/internal/testing/TestScheduler";

@Injectable({
    providedIn: 'root'
})
export class PriceMatrixService {
    baseUrl = environment.baseUrl + 'pricematrix';
    constructor(private http: HttpClient) { }

    getPriceMatrixDetailsForStream(customerId: number, streamId: number, sid: string, hid: string, dateReceived: string)
    : Observable<GetPriceMatrixForStreamResponse> {

        const params = new URLSearchParams();
        params.append('customerId', customerId.toString());
        params.append('streamId', streamId.toString());
        params.append('sid', sid.toString());
        params.append('hid', hid.toString());
        params.append('DateReceived', dateReceived ?? '');

        var url = `${this.baseUrl}/GetPriceMatrix?${params.toString()}`;
        return this.http.get<GetPriceMatrixForStreamResponse>(url);
    }

    getFeeCategoryValues(customerId: number, streamId: number, sid: string, hid: string, dateReceived: string): Observable<any> {
     const params = new URLSearchParams();
        params.append('customerId', customerId.toString());
        params.append('streamId', streamId.toString());
        params.append('sid', sid.toString());
        params.append('hid', hid.toString());
        params.append('dateReceived', dateReceived ?? '');

        var url = `${this.baseUrl}/GetFeeCategoryValues?${params.toString()}`;
        return this.http.get<any>(url);
  }
}